import {
  TrackingInfoData,
  TrackingInfoRequest,
  TrackPageData,
  TrackPageRequest,
} from "@/type";
import http from "@/utils/http";

/** 获取追踪页面数据（设置 + 多语言文本） */
export const getTrackPageData = async (params: TrackPageRequest): Promise<TrackPageData> => {
  return http.get<TrackPageData>(
    "/api/v1/client/page_setting",
    params as unknown as Record<string, unknown>,
  );
};

/** 查询物流信息 */
export const queryTrackingInfo = async (
  params: TrackingInfoRequest,
): Promise<TrackingInfoData> => {
  return http.get<TrackingInfoData>("/api/v1/client/tracking_info", params as unknown as Record<string, unknown>);
};
